module.exports = __webpack_public_path__ + "img/portfolio-door_on.368fff61.png";